import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

import { storeToRefs } from 'pinia'

import LinkSwitcher from '@/components_new/LinkSwitcher.vue'
import { useGeneralStore } from '@/store/general-store'


export default /*@__PURE__*/_defineComponent({
  __name: 'PromoCategoriesSwitchers',
  props: {
    position: {}
  },
  setup(__props: any) {

const generalStore = useGeneralStore()
const { promoCategoriesList } = storeToRefs(generalStore)

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.$style.promo_list, props.position && _ctx.$style[props.position]])
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(promoCategoriesList), ({ location, title, id }) => {
      return (_openBlock(), _createBlock(LinkSwitcher, {
        key: id,
        class: _normalizeClass(_ctx.$style.switcher),
        title: title,
        icon: id,
        to: location,
        dataInterfaceTarget: "search-promo-category"
      }, null, 8, ["class", "title", "icon", "to"]))
    }), 128))
  ], 2))
}
}

})